import { render, staticRenderFns } from "./GetGptSuggestionButton.vue?vue&type=template&id=384f60d9&"
import script from "./GetGptSuggestionButton.vue?vue&type=script&lang=js&"
export * from "./GetGptSuggestionButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports